import Axios from 'axios'
import {activityDiscountTypeUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_activity_discount_types (context) {
    Axios.get(activityDiscountTypeUrls.getAllActivityDiscountTypes).then(function (response) {
      context.commit('GET_ALL_A_DISCOUNT_TYPES', response.data)
    })
  },
  get_activity_discount_types (context, publicId) {
    Axios.get(activityDiscountTypeUrls.getActivityDiscountTypes + publicId).then(function (response) {
      context.commit('GET_A_DISCOUNT_TYPES', response.data)
    })
  },
  get_deleted_activity_discount_types (context) {
    Axios.get(activityDiscountTypeUrls.getDeletedActivityDiscountType).then(function (response) {
      context.commit('GET_DELETED_A_DISCOUNT_TYPES', response.data)
    })
  },
  get_activity_discount_type (context, publicId) {
    Axios.get(activityDiscountTypeUrls.getActivityDiscountType + publicId).then(function (response) {
      context.commit('GET_A_DISCOUNT_TYPE', response.data)
    })
  },
  post_activity_discount_type (context, data) {
    Axios.post(activityDiscountTypeUrls.postActivityDiscountType, data).then(function () {
      context.dispatch('get_all_activity_discount_types')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  update_activity_discount_type (context, data) {
    Axios.post(activityDiscountTypeUrls.editActivityDiscountType, data).then(function () {
      context.dispatch('get_all_activity_discount_types')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_activity_discount_type (context, publicId) {
    Axios.get(activityDiscountTypeUrls.deleteActivityDiscountType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_A_DISCOUNT_TYPES', response.data)
      router.push({
        name: 'Module.DeletedActivityDiscountTypes'
      })
    })
  },
  restoreActivityDiscountType (context, publicId) {
    Axios.get(activityDiscountTypeUrls.restoreActivityDiscountType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_A_DISCOUNT_TYPES', response.data)
      router.push({
        name: 'Module.ActivityDiscountTypes'
      })
    })
  }
}
